<template>
  <div>
    <div class="section">
      <h3 class="section-heading" v-html="$store.state.texts.car.title"></h3>
    </div>

    <div class="section dropdown">
      <div class="form-group required" aria-required="true">
          <label for="dealer" v-html="$store.state.texts.car.model.title"></label>
          <div class="custom-selectbox">
              <select name="dealer" id="dealer" v-model="carModel" @change="$store.state.validation.model = true">
                  <option class="selected-value" selected="selected" disabled="disabled" v-html="$store.state.texts.car.model.select"></option>
                  <option v-for="(car, index) in $store.state.dropdowns.models" :key="index" v-bind:value="car">{{ car.name }}</option>
              </select>
              <span class="selectedValue" v-if="$store.state.form.car.model === null" :class="{isInvalid: !$store.state.validation.model && $store.state.submitted}" v-html="$store.state.texts.car.model.select"></span>
              <span class="selectedValue" v-else>{{ $store.state.form.car.model.name }}</span>
              <span class="error-message" v-if="!$store.state.validation.model && $store.state.submitted" v-html="$store.state.texts.car.model.error"></span>
          </div>
      </div>
    </div>

    <div class="section dropdown">
      <div class="form-group required" aria-required="true">
          <label for="dealer" v-html="$store.state.texts.car.age.title"></label>
          <div class="custom-selectbox">
              <select name="dealer" id="dealer" v-model="$store.state.form.car.year" @change="$store.state.validation.age = true">
                  <option class="selected-value" selected="selected"  disabled="disabled" v-html="$store.state.texts.car.age.select"></option>
                  <option v-for="(year, index) in years" :key="index" v-bind:value="year">{{ year }}</option>
              </select>
              <span class="selectedValue" v-if="$store.state.form.car.year === ''" v-html="$store.state.texts.car.age.select"></span>
              <span class="selectedValue" v-else>{{ $store.state.form.car.year }}</span>
              <span class="error-message" v-if="!$store.state.validation.age && $store.state.submitted" v-html="$store.state.texts.car.age.error"></span>
          </div>
      </div>
    </div>

    <div class="textfield section">
      <div class="form-group">
        <label for="chassie" v-html="$store.state.texts.car.vin.title"></label>
        <div class="form-group-container">
          <input id="chassie" name="chassie" :placeholder="$store.state.texts.car.vin.placeholder" v-model="$store.state.form.car.vin" type="text">
        </div>
      </div>
    </div>

    <div class="textfield section">
      <div class="form-group">
        <label for="kilometers" v-html="$store.state.texts.car.milage.title"></label>
        <div class="form-group-container">
          <input id="kilometers" name="kilometers" v-model="$store.state.form.car.kilometers"  type="text">
        </div>
      </div>
    </div>

    <div class="checkbox section">
      <div class="form-group checkbox">
        <div class="checkbox-container">
          <input id="replacementVehicle" name="replacementVehicle" v-model="$store.state.form.car.replacement" type="checkbox">
          <label for="replacementVehicle" v-html="$store.state.texts.car.testDrive">
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'Car',
  data () {
    return {
      years: [
        '2020.',
        '2019.',
        '2018.',
        '2017.',
        '2016.',
        '2015.',
        '2014.',
        '2013.',
        '2012.',
        '2011.',
        '2010.',
        '2009.',
        '2008.',
        '2007.',
        '2006.',
        '2005.',
        '2004.',
        '2003.',
        '2002.',
        '2001.',
        '2000.',
        '1999.',
        '1998.',
        '1997.',
        '1996.',
        '1995.',
        '1994.',
        '1993.',
        '1992.',
        '1991.',
        '1990.'
      ]
    }
  },
  // created () {
  //   console.log('created')
  //   this.$store.state.form.car = {}
  // },
  validations: {
    carModel: {
      required
    }
    // carVinNumber: {
    //   required
    // }
  },
  computed: {
    // TWO WAY DATA BINDING FOR CAR MODEL
    carModel: {
      get () {
        return this.$store.getters.carModel
      },
      set (value) {
        this.$store.commit('updateCarModel', value)
      }
    }
    // // TWO WAY DATA BINDING FOR CAR VIN NUMBER
    // carVinNumber: {
    //   get () {
    //     return this.$store.state.form.car.vin
    //   },
    //   set (value) {
    //     this.$store.commit('updateCarVinNumber', value)
    //   }
    // }
  },
  methods: {
    fieldValidations (validation, storeObj) {
      if (validation === false) {
        this.$store.state.validation[storeObj] = true
      } else {
        this.$store.state.validation[storeObj] = false
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  //ERROR HANDLING
  .isInvalid {
    border: 2px solid red!important;
  }
  input.isInvalid::placeholder {
    color: red;
  }
  .error-message {
    display: block;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/Car.vue